import React, { useState } from "react";
import { Button, Modal, Radio } from "antd";
import TextArea from "antd/es/input/TextArea";
import "./style.css";
import { ErrorDeactivate } from "../../../assets/icons";
import ConfirmAccDeletionDeactivation from "./ConfirmAccDeletionDeactivation";
import { Form, Formik } from "formik";
import { useTranslation } from "../../../i18n/LanguageContext";

const DeleteDeactivateAcc = ({
   open,
   onCancel,
   setOpen,
   title,
   description,
   buttonText,
   action
}) => {
   const { t } = useTranslation();
   const [openConfirmDeactivation, setOpenConfirmDeactivation] = useState(false);
   const [formInitialValues, setFormInitialValues] = useState({ reason: "", description: "" });
   const [selectedReason, setSelectedReason] = useState("");

   // Function to open the confirmation modal
   const showModal = () => {
      setOpenConfirmDeactivation(true);
      setOpen(false);
   };

   const onClose = () => {
      setOpenConfirmDeactivation(false);
      setFormInitialValues({ reason: "", description: "" });
   };

   const confirmProps = {
      openConfirmDeactivation,
      onCancel: onClose,
      title: action === "delete" ? t("confirm-account-deletion-title") : t("confirm-account-deactivation-title"),
      description:
         action === "delete"
            ? t("confirm-delete-account-description")
            : t("confirm-deactivate-account-description"),
      otherDesc: t("confirm-action-other-desc"),
      button: action === "delete" ? t("delete-account-title") : t("deactivate-account-title")
   };

   const handleFormSubmit = (values) => {
      setFormInitialValues(values);
      showModal(action);
   };

   const reasons =
      action === "delete"
         ? [
              t("delete-reason-1"),
              t("delete-reason-2"),
              t("delete-reason-3"),
              t("delete-reason-4")
           ]
         : [
              t("deactivate-reason-1"),
              t("deactivate-reason-2"),
              t("deactivate-reason-3"),
              t("deactivate-reason-4")
           ];

   return (
      <>
         <Modal
            open={open}
            onCancel={onCancel}
            className="modalContainer"
            destroyOnClose
            footer={[]}
         >
            <Formik
               initialValues={formInitialValues}
               onSubmit={handleFormSubmit}
               enableReinitialize
            >
               {({ handleChange, values, setFieldValue }) => (
                  <Form>
                     <div className="d-flex flex-column" style={{ gap: "24px" }}>
                        <div className="d-flex align-items-center flex-column firstSection pb-3">
                           <div className="d-flex justify-content-center align-items-center innerSection">
                              <img src={ErrorDeactivate} alt="error icon" />
                              <span className="title-span">{title}</span>
                           </div>
                           <span className="span-description">{description}</span>
                        </div>
                        <div className="d-flex flex-column" style={{ gap: "12px" }}>
                           <span className="span-style">
                              {action === "delete"
                                 ? t("delete-account-feedback-prompt")
                                 : t("deactivate-account-feedback-prompt")}
                           </span>
                           <div className="d-flex flex-column" style={{ gap: "16px" }}>
                              <Radio.Group
                                 name="description"
                                 onChange={(e) => {
                                    const value = e.target.value;
                                    setFieldValue("description", value);
                                    setSelectedReason(value);
                                 }}
                                 value={selectedReason}
                                 className="d-flex flex-column"
                                 style={{ gap: "14px" }}
                              >
                                 {reasons.map((reason) => (
                                    <Radio key={reason} value={reason} className="radio-container">
                                       {reason}
                                    </Radio>
                                 ))}

                                 <Radio className="radio-container" value="Other">
                                    {t("other-please-specify-label")}
                                 </Radio>
                              </Radio.Group>
                              <TextArea
                                 name="description"
                                 onChange={(e) => {
                                    const inputValue = e.target.value;
                                    setFieldValue("description", inputValue);
                                    if (["Other"].includes(inputValue)) {
                                       setSelectedReason(inputValue);
                                    }
                                 }}
                                 value={values?.description}
                                 placeholder={t("enter-your-answer-placeholder")}
                                 maxLength={100}
                                 showCount={true}
                              />
                           </div>
                        </div>
                        <div>
                           <span className="span-style">
                              {action === "delete"
                                 ? t("delete-account-followup-question")
                                 : t("deactivate-account-followup-question")}
                           </span>
                           <TextArea
                              type="text"
                              name="reason"
                              onChange={handleChange}
                              value={values?.reason}
                              placeholder={t("enter-your-answer-placeholder")}
                              maxLength={100}
                              showCount={true}
                           ></TextArea>
                        </div>
                        <div
                           className="footer-buttons d-flex justify-content-center"
                           style={{ gap: "40px" }}
                        >
                           <Button className="cancel-deactivation" onClick={onCancel}>
                              {t("cancel")}
                           </Button>
                           <Button className="deactivate-button" htmlType="submit">
                              {buttonText}
                           </Button>
                        </div>
                     </div>
                  </Form>
               )}
            </Formik>
         </Modal>
         <ConfirmAccDeletionDeactivation
            {...confirmProps}
            action={action}
            formData={formInitialValues}
         />
      </>
   );
};

export default DeleteDeactivateAcc;
